let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aQp8v"), load("2jsRt"), load("69F1b")]).then(() => parcelRequire('2QizT'));